import { BaseWebComponentController, IListenerConfig } from '../../../framework/BaseWebComponentController';
import { MobileSecurityCustomerViewWebComponent } from '../component/MobileSecurityCustomerViewWebComponent';
import { MobileSecurityCustomerViewView } from '../view/MobileSecurityCustomerViewView';
import { template } from '../view/template';
import { MobileSecurityCustomerViewRepository } from '../repository/MobileSecurityCustomerViewRepository';
import { AccountAction, MobileSecurityCompanyRecord } from '../../mobileSecurityCompanyGrid/types';
import { showErrorToast } from '@nirvana/shared/common';
import { openConsoleForCurrentUserAndCompany } from '../../common/services';

export class MobileSecurityCustomerViewController extends BaseWebComponentController {
  public component: MobileSecurityCustomerViewWebComponent;
  public view!: MobileSecurityCustomerViewView;
  public viewConstructor: typeof MobileSecurityCustomerViewView;
  public dataRepository: MobileSecurityCustomerViewRepository;
  public company: MobileSecurityCompanyRecord | undefined;

  constructor(component: MobileSecurityCustomerViewWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: MobileSecurityCustomerViewView,
      viewTemplate: template,
      dataRepositoryConstructor: MobileSecurityCustomerViewRepository,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$createAccountButton,
        event: 'click',
        callback: () => this.dispatchEvent(AccountAction.CREATE, this.company),
      },
      {
        element: this.view.dom.$openConsoleButton,
        event: 'click',
        callback: this.handleOpenMobileSecurityConsole,
      },
      {
        element: this.view.dom.$sendEmailsButton,
        event: 'click',
        callback: () => this.dispatchEvent(AccountAction.ACTIVATION, this.company),
      },
    ];
  }

  async getDataForView(): Promise<MobileSecurityCompanyRecord | undefined> {
    this.company = await this.dataRepository.getCompany();
    return this.company;
  }

  dispatchEvent(type: string, company: MobileSecurityCompanyRecord | undefined) {
    if (company === undefined) return;

    this.view.dom.$wrapper.dispatchEvent(
      new CustomEvent(type, {
        detail: {
          id: company._id,
          name: company.companyName,
          fromCustomerView: true,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  async refresh() {
    this.view.setLoadingState();
    await this.render();
  }

  private async handleOpenMobileSecurityConsole() {
    if (!this.company) {
      console.error('Cannot open console due to unknown company details.');
      return;
    }

    this.view.dom.$openConsoleButton.disabled = true;
    this.view.dom.$openConsoleButton.showSpinner = true;

    try {
      await openConsoleForCurrentUserAndCompany(this.company._id, this.dependencies);
    } catch (error) {
      showErrorToast(error);
    }

    this.view.dom.$openConsoleButton.disabled = false;
    this.view.dom.$openConsoleButton.showSpinner = false;
  }
}
